module.exports = __webpack_public_path__ + "img/loading-black.64c74b73.svg";